import { render, staticRenderFns } from "./mail-template-config.vue?vue&type=template&id=3e71539b&"
import script from "./mail-template-config.vue?vue&type=script&lang=js&"
export * from "./mail-template-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports